import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';


const Footer: React.FC = () => {
  const [showTelegramModal, setShowTelegramModal] = React.useState(false);
  const [showDevModal, setShowDevModal] = React.useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowTelegramModal(true);
  };

  const handleDevClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowDevModal(true);
  }

  const handleTelegramConfirm = () => {
    window.open('https://t.me/DaniilSnejniy', '_blank');
    setShowTelegramModal(false);
  }

  return (
  <footer id="site-footer" className="footer">
    <div className="footer__inner">
      <div className="footer__columns">

        <div className="footer__column">
          <h4 className="footer__title">Roadmap</h4>
          <ul className="footer__list">
            <li><Link className="footer__link" to="/roadmap" onClick={scrollToTop}>Фичи</Link></li>
            <li><Link className="footer__link" to="/milestones" onClick={scrollToTop}>Этапы</Link></li>
            <li><Link className="footer__link" to="/changelog" onClick={scrollToTop}>Обновления</Link></li>
          </ul>
        </div>

        <div className="footer__column">
          <h4 className="footer__title">About</h4>
          <ul className="footer__list">
            <li><Link className="footer__link" to="/about" onClick={scrollToTop}>О проекте</Link></li>
            <li><a className="footer__link" href="#team" onClick={handleDevClick}>Команда</a></li>
          </ul>
        </div>

        <div className="footer__column">
          <h4 className="footer__title">Support</h4>
          <ul className="footer__list">
            <li><a className="footer__link" href="#help" onClick={handleDevClick}>Центр помощи</a></li>
            <li><a className="footer__link" href="#contact" onClick={handleContactClick}>Связаться</a></li>
            <li><a className="footer__link" href="#support-project" onClick={handleDevClick}>Поддержать проект</a></li>
            <li><Link className="footer__link" to="/join" onClick={scrollToTop}>Хочу в команду!</Link></li>
          </ul>
        </div>

      </div>
      <span className="footer__copy">© {new Date().getFullYear()} Celestix</span>
    </div>

    {showTelegramModal && (
      <div className="modal-overlay" onClick={() => setShowTelegramModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <h3 className="modal-title">Переход в Telegram</h3>
          <p className="modal-text">Вы будете перенаправлены в Telegram для связи с нами.</p>
          <div className="modal-actions">
            <button className="modal-button modal-button--primary" onClick={handleTelegramConfirm}>
              Перейти
            </button>
            <button className="modal-button modal-button--secondary" onClick={() => setShowTelegramModal(false)}>
              Отмена
            </button>
          </div>
        </div>
      </div>
    )}

    {showDevModal && (
      <div className="modal-overlay" onClick={() => setShowDevModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <h3 className="modal-title">В разработке</h3>
          <p className="modal-text">Этот раздел находится в разработке. Следите за обновлениями!</p>
          <div className="modal-actions">
            <button className="modal-button modal-button--primary" onClick={() => setShowDevModal(false)}>
              Понятно
            </button>
          </div>
        </div>
      </div>
    )}
  </footer>
  );
}

export default Footer;
